export default {
  chatWidget: {
    chatWithUs: 'チャット',
    welcomeTitle: 'Bookivoへようこそ!',
    welcomeMessage: '本日どのようなご用件でお越しでしょうか？',
    continueChat: 'チャットを続ける',
    startConversation: '会話を始める',
    formTitle: 'あなたについて教えてください',
    namePlaceholder: 'お名前',
    emailPlaceholder: 'メールアドレス',
    phonePlaceholder: '電話番号',
    nameRequired: 'お名前を入力してください',
    emailRequired: 'メールアドレスを入力してください',
    emailInvalid: '有効なメールアドレスを入力してください',
    phoneRequired: '電話番号を入力してください',
    startChat: 'チャットを開始',
    chatTitle: 'サポートチャット',
    chatTitleNoAgent: '接続中...',
    endChat: 'チャットを終了',
    inputPlaceholder: 'メッセージを入力...',
    greeting: 'こんにちは',
    greetingMessage: '本日どのようなご用件でお越しでしょうか？',
    emoji: '絵文字',
    uploadImage: '画像をアップロード',
    sending: '送信中...',
    uploadFailed: 'アップロードに失敗しました。もう一度お試しください',
    fileTooLarge: 'ファイルサイズは10MBを超えることはできません',
    invalidFileType: '画像ファイルのみアップロード可能です',
    sendFailed: 'メッセージの送信に失敗しました。もう一度お試しください',
    imageSendFailed: '画像の送信に失敗しました。もう一度お試しください',
    connectionLost: '接続が切断されました。チャットを閉じて再度接続してください',
    uploading: '画像をアップロード中...',
    sessionEnded: 'セッションが終了しました',
    rating: {
      title: 'ご利用いただきありがとうございます。サービスを評価してください。',
      satisfied: '満足',
      dissatisfied: '不満',
      placeholder: 'ご意見・ご要望をお聞かせください',
      submit: '評価を送信',
      endChat: '終了',
      backToChat: 'チャットに戻る',
      success: 'ご意見ありがとうございます！'
    }
  }
}
